import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsDevice } from '../DeviceSettings';
import EnableOrDisableDeviceMutationContainer from 'settings/containers/EnableOrDisableDeviceMutationContainer';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import RemoveDeviceFromUserConfirmDialog from 'settings/components/RemoveDeviceFromUserConfirmDialog';
import TextWithIcon from 'components/TextWithIcon';
import TooltipTrigger from 'components/TooltipTrigger';

export type Props = {
  SMSDevice: DeviceSettingsDevice;
  deviceIsOnlyLoginDevice: boolean;
};

type State = {
  confirmRemoveDialogIsOpen: boolean;
};

export default class DeviceSettingsSMSItem extends React.Component<Props, State> {
  state = {
    confirmRemoveDialogIsOpen: false,
  };

  showConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: true });
  };

  hideConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: false });
  };

  renderSecondaryText = () => {
    const { SMSDevice } = this.props;
    const { reachabilityInfo } = SMSDevice;

    if (reachabilityInfo && reachabilityInfo.reasonShort && reachabilityInfo.reasonLong) {
      return (
        <Link
          href={LinkConstants.UNREACHABLE_DEVICES}
          target="_blank"
          data-test="unreachable-device-link">
          <TooltipTrigger placement="left" tooltip={reachabilityInfo.reasonLong}>
            <TextWithIcon icon="explanation-circle" iconColor="apple" gutter="xxsmall">
              {reachabilityInfo.reasonShort}
            </TextWithIcon>
          </TooltipTrigger>
        </Link>
      );
    } else {
      return 'Text messages';
    }
  };

  render() {
    const { SMSDevice, deviceIsOnlyLoginDevice } = this.props;

    return (
      <React.Fragment>
        <Modal data-test="remove-sms-device-modal" isOpen={this.state.confirmRemoveDialogIsOpen}>
          <RemoveDeviceFromUserConfirmDialog
            deviceName={SMSDevice.label || 'Your device'}
            deviceId={SMSDevice.id}
            onRequestHide={this.hideConfirmRemoveDialog}
          />
        </Modal>
        <EnableOrDisableDeviceMutationContainer>
          {enableOrDisableDevice => (
            <DeviceSettingsItemTemplate
              deviceType="sms"
              deviceExists
              deviceIsRostered={SMSDevice.rostered}
              deviceIsEnabled={SMSDevice.enabled}
              deviceIsOnlyLoginDevice={deviceIsOnlyLoginDevice}
              deviceCanBeEnabledOrDisabled
              primaryTextLabel={SMSDevice.label}
              secondaryTextLabel={this.renderSecondaryText()}
              onRemoveDevice={this.showConfirmRemoveDialog}
              onEnableOrDisableDevice={() =>
                enableOrDisableDevice({
                  variables: { deviceId: SMSDevice.id, enabled: !SMSDevice.enabled },
                })
              }
            />
          )}
        </EnableOrDisableDeviceMutationContainer>
      </React.Fragment>
    );
  }
}
